// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2y8H6","inputWrap":"styles_inputWrap__3Ba5G","input":"styles_input__iX6eo"};